import styles from "./gps-upload-section.module.css";
import { useUploadsStore } from "entity-store/uploads-store/uploads-store";
import { useState, useEffect } from "react";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { loadGPXFromURL } from "PosterEditor/utils/file-import";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { DeleteButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";

interface GPSUploadSectionProps {
  emptyTitle?: string;
  emptyDescription?: string;
  onFoundGPX: (found: boolean) => void;
}

export const GPSUploadSection = (props: GPSUploadSectionProps) => {
  const { setCoordinates } = usePosterProject();
  const { gpxURLsInUploadsFolder, deleteGPXWithURL } = useUploadsStore();

  const [gpxURLs, setGpxURLs] = useState<string[]>([]);

  const applyGPX = (gpxURLs: string[]) => {
    if (gpxURLs.length === 0) {
      console.warn("No GPX URLs provided.");
      return;
    }
    let first = gpxURLs[0];
    loadGPXFromURL(first)
      .then((data) => {
        if (data?.coordinates) {
          setCoordinates(data.coordinates, data.name ?? "GPX Route", data.data);
        } else {
          console.error("No coordinates found in GPX data.");
        }
      })
      .catch((error) => {
        console.error("Error loading GPX data:", error);
      });
  };

  const deleteGPX = () => {
    let first = gpxURLs[0];
    if (first) {
      deleteGPXWithURL(first).then(() => {
        setGpxURLs([]);
      });
    }
  };

  useEffect(() => {
    // Fetch the GPX URLs from the uploads folder
    const fetchGpxURLs = async () => {
      const urls = await gpxURLsInUploadsFolder();
      setGpxURLs(urls);
      props.onFoundGPX(urls.length > 0);
    };

    fetchGpxURLs();
  }, []);

  if (gpxURLs.length === 0) {
    return null;
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionBody}>
        <Content
          onClickApply={() => {
            applyGPX(gpxURLs);
          }}
          onClickDelete={deleteGPX}
        />
      </div>
    </div>
  );
};

interface ContentProps {
  onClickApply: () => void;
  onClickDelete: () => void;
}

const Content = (props: ContentProps) => {
  return (
    <div className={styles.container} onClick={props.onClickApply}>
      <div className={styles.iconContainer}>
        <UIIcon iconName="IPHONE-ROUTE" variant="SELECTED" size={40} />
      </div>
      <div className={styles.metaContent}>
        <h2>Route uploaded from iPhone!</h2>
        <div className={styles.ctas}>
          <CTAButton
            variant="PRIMARY"
            onClick={props.onClickApply}
            title="APPLY"
          />
          <DeleteButton
            onClick={() => {
              props.onClickDelete();
            }}
          />
        </div>
      </div>
    </div>
  );
};
